import { createRoot } from 'react-dom/client'
import Storybook from './index.stories'
import { StrictMode } from 'react'
// oxlint-disable-next-line import/no-unassigned-import -- bundled-dev shared dependency ordering workaround
import './bundled-dev-lazy-runtime'
// oxlint-disable-next-line import/no-unassigned-import -- anchors Turso worker chunks eagerly, see file header
import './bundled-dev-turso-worker-anchor'

// oxlint-disable-next-line typescript/no-non-null-assertion -- we know root exists
const root = createRoot(document.querySelector('#root')!)

function render(Component: typeof Storybook) {
  root.render(
    <StrictMode>
      <Component />
    </StrictMode>,
  )
}

render(Storybook)

// Structural story HMR: a rename/add/remove in any leaf .stories file changes that
// module's export set, so Fast Refresh cannot accept it and the invalidation bubbles
// up through the aggregators to `./index.stories` (which rebuilds `rootStory` with the
// new tree). Accepting it here re-renders the root with the fresh tree instead of a
// full page reload, preserving in-page state (active story, controls).
if (import.meta.hot) {
  import.meta.hot.accept(
    './index.stories',
    (mod: { default: typeof Storybook } | undefined) => {
      if (mod) render(mod.default)
    },
  )
}
